var map = {
	"./ds-action-menu_2.entry.js": [
		40083,
		83
	],
	"./ds-breadcrumb-element_3.entry.js": [
		53248,
		3949,
		3248
	],
	"./ds-button-component_3.entry.js": [
		24646,
		3949,
		4646
	],
	"./ds-button_2.entry.js": [
		38851,
		8851
	],
	"./ds-contextual-navigation-country-selector_12.entry.js": [
		69179,
		2076,
		9179
	],
	"./ds-contextual-navigation.entry.js": [
		98932,
		2076,
		8932
	],
	"./ds-custom-scrollbar_2.entry.js": [
		72759,
		215,
		2759
	],
	"./ds-dropdown-breadcrumb-item.entry.js": [
		6925,
		6925
	],
	"./ds-dropdown-breadcrumbs_2.entry.js": [
		63989,
		3949,
		3989
	],
	"./ds-dropdown-nav-item_3.entry.js": [
		43009,
		3949,
		2076,
		3009
	],
	"./ds-flex-col.entry.js": [
		81910,
		2076,
		1910
	],
	"./ds-flex-grid.entry.js": [
		32786,
		2076,
		2786
	],
	"./ds-flex-row.entry.js": [
		83508,
		2076,
		3508
	],
	"./ds-footer-navigation_2.entry.js": [
		47681,
		7681
	],
	"./ds-footer.entry.js": [
		76209,
		6209
	],
	"./ds-header-mobile-return-button_2.entry.js": [
		15,
		2076,
		15
	],
	"./ds-header.entry.js": [
		81788,
		1788
	],
	"./ds-icon.entry.js": [
		53035,
		215,
		3035
	],
	"./ds-link.entry.js": [
		32250,
		2076,
		2250
	],
	"./ds-secondary-navigation.entry.js": [
		21173,
		3949,
		2076,
		1173
	],
	"./ds-social-link.entry.js": [
		62746,
		2746
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 32156;
module.exports = webpackAsyncContext;